import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../utils/api";

function Scanner() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const navigate = useNavigate();

  // Fetch batches when component mounts
  useEffect(() => {
    const fetchBatches = async () => {
      try {
        setLoadingBatches(true);
        const response = await apiService.getActiveTeacherBatches();
        if (response.data.success) {
          setBatches(response.data.batches);
        } else {
          console.error("Failed to fetch batches:", response.data.message);
        }
      } catch (err) {
        console.error("Error fetching batches:", err);
      } finally {
        setLoadingBatches(false);
      }
    };

    fetchBatches();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      if (!title) {
        setTitle(selectedFile.name.split(".")[0]);
      }

      // Create a preview for the image
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgSrc(reader.result);
      });
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file to scan");
      return;
    }

    if (!minutes) {
      setError("PLese sleelct minute");
      return;
    }

    // Check if batch is selected - only required for teachers
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role === "teacher" && !selectedBatch) {
      setError("Please select a batch for this document");
      return;
    }

    setScanning(true);
    setError("");

    try {
      const fileToUpload = file;
      console.log("Using image:", fileToUpload);

      const formData = new FormData();
      formData.append("document", fileToUpload);
      formData.append("title", title);
      formData.append("minutes", minutes);

      // Add batch ID to form data if selected
      if (selectedBatch) {
        formData.append("batchId", selectedBatch);
      }

      // Log the form data to verify what's being sent
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await apiService.scanDocument(formData);
      const data = response.data;

      if (data.success) {
        navigate(`/dashboard/teacher/documents/${data.document.id}`);
      } else {
        setError(data.message || "Failed to scan document");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error scanning document");
      console.error(err);
    } finally {
      setScanning(false);
    }
  };

  // Check if current user is a teacher
  const isTeacher = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.role === "teacher";
  };

  return (
    <div className="scanner-container">
      <h2>Scan Document</h2>

      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label>Document Title:</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter document title" required />
        </div>

        <div className="form-group">
          <label>Assign to Batch:</label>
          <select value={selectedBatch} onChange={(e) => setSelectedBatch(e.target.value)} required disabled={loadingBatches}>
            <option value="">Select a batch</option>
            {batches.map((batch) => (
              <option key={batch.id} value={batch.id}>
                {batch.name}
              </option>
            ))}
          </select>
          {loadingBatches && <span className="loading-text">Loading batches...</span>}
        </div>

        <div className="form-group">
          <label>Minutes:</label>
          <input type="number" value={minutes} onChange={(e) => setMinutes(Math.max(1, parseInt(e.target.value) || 1))} min="1" required />
        </div>

        <div className="file-input-container">
          <input type="file" onChange={handleFileChange} accept="image/*" id="file-upload" className="file-input" />
          <label htmlFor="file-upload" className="file-label">
            {file ? file.name : "Choose a file"}
          </label>
        </div>

        {imgSrc && (
          <div className="image-preview">
            <h4>Preview:</h4>
            <img src={imgSrc} alt="Document preview" style={{ maxWidth: "100%", maxHeight: "300px" }} />
          </div>
        )}

        {error && <p className="error-message">{error}</p>}

        <div className="button-group">
          <button type="button" onClick={() => navigate("/dashboard/teacher")} className="cancel-button">
            Cancel
          </button>
          <button type="submit" className="scan-button" disabled={!file || scanning || (isTeacher() && !selectedBatch)}>
            {scanning ? "Scanning..." : "Scan Document"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Scanner;
